import React from 'react';
import { User } from '../../types';
import Avatar from '../common/Avatar';

interface CollaboratorReviewSectionProps {
  collaborators: any[];
  reviews: {[key: string]: {rating: number, comment: string}};
  onReviewChange: (collaboratorId: string, field: 'rating' | 'comment', value: any) => void;
  currentUser: User | null;
}

const CollaboratorReviewSection: React.FC<CollaboratorReviewSectionProps> = ({ 
  collaborators, 
  reviews, 
  onReviewChange,
  currentUser
}) => {

  return (
    <div className="review-section mt-4 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
      <h4 className="text-lg font-semibold mb-3 text-gray-900 dark:text-white">Rate Your Collaborators</h4>
      <div>
        {collaborators
          .filter(c => c.is_portal_user && c.user_id && c.user_id !== currentUser?.id)
          .map((collaborator) => (
        <div key={collaborator.id} className="mb-3 p-3 bg-white dark:bg-gray-900 rounded border border-gray-200 dark:border-gray-800">
          <div className="flex items-center mb-2">
            <Avatar 
              src={collaborator.profile_pic_thumb_signed || collaborator.profile_pic} 
              alt={collaborator.name}
              size="sm"
              className="mr-2"
            />
            <span className="font-medium text-gray-900 dark:text-white">{collaborator.name}</span>
          </div>
          
          {/* Star Rating */}
          <div className="flex items-center mb-2">
            <span className="text-sm text-gray-600 dark:text-gray-400 mr-2">Rating:</span>
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                onClick={() => onReviewChange(collaborator.user_id, 'rating', star)}
                className={`text-2xl ${
                  (reviews[collaborator.user_id]?.rating || 0) >= star 
                    ? 'text-yellow-400' 
                    : 'text-gray-300 dark:text-gray-700'
                } hover:text-yellow-400 transition-colors`}
              >
                ★
              </button>
            ))}
          </div>
          
          {/* Comment */}
          <textarea
            placeholder="Share your experience (optional)"
            value={reviews[collaborator.user_id]?.comment || ''}
            onChange={(e) => onReviewChange(collaborator.user_id, 'comment', e.target.value)}
            className="w-full p-2 border border-gray-200 dark:border-gray-700 rounded text-sm resize-none bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-1 focus:ring-teal-500"
            rows={1}
          />
        </div>
      ))}
      </div>
    </div>
  );
};

export default CollaboratorReviewSection;
